import { define, type, auto } from 'type-r';
import Collection, {Record} from './base'
import Product from './product'
import MenuItemSlot, {MenuItemSlotCollection} from './menu_slot'

@define
export class MenuItemCollection<R extends MenuItem = MenuItem> extends Collection<R> {
}

@define
export default class MenuItem extends Record {
    static Collection = MenuItemCollection
    @type(String).value('').as title: string
    @type(Number).value(0.0).as price: number
    @type(MenuItemSlotCollection).as slots: MenuItemSlotCollection
    
    getPrice() {
	var price = this.price;
	this.slots.each(function(slot) {
	    if (!slot.selected && !slot.defprod) return;
	    if (slot.selected) {
		if (slot.selected.variants.length == 0)
		    price += slot.selected.price;
		else if (slot.selected.selected)
		    price += slot.selected.selected.price;
		else if (slot.selected.defprod)
		    price += slot.selected.defprod.price;
	    }
	    else if (slot.defprod) {
		if (slot.defprod.variants.length == 0)
		    price += slot.defprod.price;
		else if (slot.defprod.defprod)
		    price += slot.defprod.defprod.price;
	    }
	});
	
	return price;
    }
    
    toData(opts?:any) {
	var data:any[] = [];
	this.slots.each(function(slot) {
	    var d = slot.toData();
	    data.push(d);
	});
	return data;
    }
}
